// change
// value
// Möglichkeit 1 -> all -> hide();
// -> class: term-id-{value} => show();
// Möglichkeit 2 -> class not: term-id-{value} => hide();

export function seminar_filter() {
  if($('.seminare').length > 0){
    $('.seminare').each(function(){
      let $container = $(this);

      $container.find('.seminar-categories select').on('change', function () {
        let value = $(this).val();

        if(value ==''){
          $container.find( '.seminar-list li' ).show();
        } else {
          $container.find( '.seminar-list li' ).each(function () {
            if ($(this).hasClass(value)) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/seminar-filter.js